export default "__VITE_ASSET__zYe97yON__"